<div class="table-name">{{ pageTitle$ | async }}</div>
<div class="table-container">
  <div class="table-header-area">
    <div class="table-header-left">
      <app-org-management-tabs></app-org-management-tabs>
    </div>
    <div class="table-header-right">
      @if (headerActions$ | async; as templateRef) {
        <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
      }
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
